import React from "react";
import { ShieldCheck } from "lucide-react";
import { useSubscription } from "../../lib/subscription";

/**
 * FounderChip — compact FOUNDER #NNNN pill for the mobile app header.
 *
 * Mirrors the pill on the Earth Initiative site (earth.eviq.pro) so a
 * founding member sees the same status marker in both places. Rendered
 * next to the language switcher; hidden entirely if the current session
 * isn't a founding member.
 *
 * Design intent: quiet by default (subtle green outline), not
 * attention-grabbing — it's a recognition mark, not a nag.
 */
export const FounderChip = () => {
  const { founding } = useSubscription();
  if (!founding) return null;

  // `badge` on the subscription record looks like "#000002" — strip the
  // leading zeros for display (matches the "FOUNDER #0847" style shown
  // on earth.eviq.pro without literally hard-coding the format).
  const digits = (founding.badge || "").replace(/[^0-9]/g, "");
  const display = digits ? `#${String(parseInt(digits, 10)).padStart(4, "0")}` : "#0000";

  return (
    <div
      data-testid="mobile-app-founder-chip"
      className="inline-flex items-center gap-1 rounded-full px-2 py-1 border shrink-0"
      style={{
        borderColor: "rgba(57,255,20,0.45)",
        background: "rgba(57,255,20,0.10)",
      }}
      title={`Founding Member ${display}${founding.name ? " · " + founding.name : ""}`}
    >
      <ShieldCheck
        className="w-3 h-3"
        style={{ color: "#39FF14" }}
        strokeWidth={2.6}
      />
      <span
        className="font-mono text-[9px] uppercase tracking-[0.14em] font-semibold"
        style={{ color: "#39FF14" }}
        data-testid="mobile-app-founder-chip-badge"
      >
        Founder {display}
      </span>
    </div>
  );
};
